export default [
  {
    name: 'question',
    label: 'Character Question',
    component: 'input'
  }
];
